import React from 'react';
import './style.scss';

const CustomButton = ({
  children,
  icon,
  color = '#5E5DF0',
  onClick,
  type = 'button',
}) => {
  const dynamicStyle = {
    '--button-bg': color,
  };

  return (
    <button
      className="custom_button"
      role="button"
      onClick={onClick}
      type={type}
      style={{
        ...dynamicStyle,
        backgroundColor: color,
      }}
      
    >
      {icon && <span className="icon">{icon}</span>}
      {children}
    </button>
  );
};

export default CustomButton;
